// algolia-client.js
import { liteClient } from "algoliasearch/lite"

export const baseClient = liteClient(
  process.env.ALGOLIA_APP_ID,
  process.env.ALGOLIA_SEARCH_KEY
)

// Prevent network calls when query is empty
const searchClient = {
  ...baseClient,
  search(requests) {
    const allEmpty = requests.every(
      (req) => !req?.params?.query || req.params.query.trim() === ""
    )

    if (allEmpty) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          page: 0,
          nbPages: 0,
          processingTimeMS: 0,
          hitsPerPage: 20,
          exhaustiveNbHits: false,
          query: "",
          params: "",
        })),
      })
    }

    return baseClient.search(requests)
  },
}

export default searchClient
